import { applyCaptorQueries, QueryBuilder } from "./Helpers";
export const CaptorConnection = {
    reportsMetaData(q) {
        return applyCaptorQueries(QueryBuilder.reportsMetaData(q));
    },
    report(q) {
        return applyCaptorQueries(QueryBuilder.report(q));
    },
    annualReport(q) {
        return applyCaptorQueries(QueryBuilder.annualReport(q));
    }
};
//# sourceMappingURL=CaptorConnection.js.map